import { useEffect, useState } from 'react';
import { Checkbox } from '@airbus/components-react';
import SetColumnConfig from '../../../shared/components/grid/SetColumnConfig';

export default function ScreenAccessColumnConfig(props) {
  const { gridColumns: columnsConfig } = SetColumnConfig(props);
  const gridColumns = columnsConfig.reduce((resp, item) => {
    if (item.attrInternalName === 'access_level') {
      item.align = 'left';
      item.renderCell = (params) => (
        <RenderEditField {...{ ...params, ...props, ...props.customProps }} />
      );
    } else if (item.attrInternalName === 'role_id') {
      item.onValueChange = (params) => roleIdOnChange({ ...params, ...props.customProps });
    }
    resp.push(item);
    return resp;
  }, []);
  return { gridColumns };
}

function roleIdOnChange(props) {
  const { rowId, value, updateRow } = props;
  const updatedFields = { description: null };
  updatedFields.description = value;
  updateRow({ rowId, updatedFields });
}

function RenderEditField(params) {
  const { api, id, field, value: initialValue, setRows } = params;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(initialValue === 'S');
  }, [initialValue]);

  const handleChange = (e) => {
    const newChecked = e.target.checked;
    const check = newChecked ? 'S' : 'H';
    setChecked(newChecked);
    api.setEditCellValue({ id, field, value: check });
    setRows((allrows) => {
      const newState = [...allrows];
      const index = newState.findIndex((item) => item.id == id);
      if (index !== -1) {
        if (!newState[index].status) {
          newState[index] = {
            ...newState[index],
            status: 'E',
            access_level: check,
          };
        } else {
          newState[index] = {
            ...newState[index],
            access_level: check,
          };
        }
      }
      return newState;
    });
  };

  return <Checkbox checked={checked} onChange={handleChange} />;
}
